import { memo } from 'react';
import { styled } from 'styled-components';

import { Media } from '@/js/libs/ui';
import type { NumberInputValue } from '@/js/libs/ui/src/V2';

import { NumberFilter } from './NumberFilter';

type NumberRangeFilterProps = {
  filterMin: NumberInputValue;
  filterMax: NumberInputValue;
  onChangeMin: (value: NumberInputValue) => void;
  onChangeMax: (value: NumberInputValue) => void;
  placeholderMin?: string;
  placeholderMax?: string;
  width?: number;
};

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media ${Media.xsMax} {
    width: 100%;

    > * {
      flex: 1;
      width: auto;
    }
  }
`;

export const NumberRangeFilter = memo(function NumberRangeFilter({
  filterMin,
  filterMax,
  onChangeMin,
  onChangeMax,
  placeholderMin,
  placeholderMax,
  width,
}: NumberRangeFilterProps) {
  return (
    <Wrapper>
      <NumberFilter filter={filterMin} onChange={onChangeMin} placeholder={placeholderMin} width={width} />
      {'-'}
      <NumberFilter filter={filterMax} onChange={onChangeMax} placeholder={placeholderMax} width={width} />
    </Wrapper>
  );
});
